import React from 'react';
import { useNotify } from '../../context/NotificationContext';
import './Notification.css';

const ICONS = {
  success: '✓',
  error:   '✕',
  info:    'i',
  warning: '!',
};

export default function NotificationHost() {
  const { notifications, remove } = useNotify();
  if (!notifications.length) return null;

  return (
    <div className="notif-container">
      {notifications.map((n) => (
        <div
          key={n.id}
          className={`notif notif-${n.type}`}
          onClick={() => remove(n.id)}
        >
          <span className="notif-icon">{ICONS[n.type] || 'i'}</span>
          <span className="notif-msg">{n.message}</span>
          <button
            className="notif-close"
            onClick={(e) => { e.stopPropagation(); remove(n.id); }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
